<template>
  <div id="navigationState">
    <div id="line"></div> 
    <TextTransition 
      id="navigationContent" 
      :content="currentProject.id + ' ' + (currentProject.title.length > 5 ? currentProject.title.slice(0, 4) + '.' : currentProject.title )" 
      idName="navigationContent" 
    />    
  </div>
</template>

<script>
import TextTransition from './TextTransition.vue'
export default {
  name: 'NavigationState',
  components: { TextTransition },
  props: {
    currentProject: Object,
    projectCount: Number
  },
  watch: {
    currentProject(value) {
      this.updatePosition(value.id)
    },
  },
  data(){
    return {
      lineHeightSegment: 0,
      textHeight: 0,
      storeID: '01',
      navigationContent: null,
    }
  },
  methods: {
    updatePosition(id){
      this.storeID = id
      this.navigationContent.style.transform = `translateY(${(this.lineHeightSegment * (Number(id) - 1)) - (this.textHeight / 2)}px)`
    },
    resize(){
      this.lineHeightSegment = document.getElementById('line').getBoundingClientRect().height / (this.projectCount - 1)
      this.textHeight = this.navigationContent.getBoundingClientRect().height

      this.updatePosition(this.storeID)
    }
  },
  mounted(){
    this.navigationContent = document.getElementById('navigationContent')
    this.updatePosition(this.storeID)
  }
}
</script>

<style scoped>
#navigationState
{  
  grid-column: 1;
  grid-row: 1;

  display: flex;
  flex-direction: row;
  z-index: 5;

  pointer-events: none;
}
#line
{
  height: 30vh;
  width: 0.25vh;
  background-color: #f5f5f5;
  border-radius: 4px;
}
#navigationContent
{
  height: min-content;
  transition: clip-path 300ms, transform 500ms ease-in-out;
  margin: 0 10px;
}
@media (orientation: landscape) {
  #navigationState
  {
    margin: 5vh 3vh;
  }
}
@media (orientation: portrait) {
  #navigationState
  {
    margin: 3vh 1.5vh;
  }
}
</style>